import { format } from "date-fns";

import { CALCULATOR_STAGES } from "constants/calculator";

import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getObjectGrowthCardColumns = () => [
  {
    key: "type",
    label: "Bezeichnung",
    minWidth: 600,
    maxWidth: 800,
    justifyContent: "start",
  },
  {
    key: "quantity",
    label: "Wert",
    minWidth: 80,
    maxWidth: 120,
    justifyContent: "end",
  },
];

export const getObjectGrowthCardData = ({ calculation }) => {
  const propertyGrowthStartDate =
    calculation?.baseCalculation?.propertyGrowthStartDate;
  const finishDate = calculation?.baseCalculation?.stages?.find(
    (stage: any) => stage.type === CALCULATOR_STAGES.FINISH_STAGE
  )?.date;
  const rentStartDate = calculation?.baseCalculation?.stages?.find(
    (stage: any) => stage.type === CALCULATOR_STAGES.RENTAL_INCOME_STAGE
  )?.date;

  const propertyGrowthYear = propertyGrowthStartDate
    ? format(propertyGrowthStartDate, "yyyy")
    : "";
  const finishYear = format(finishDate, "yyyy");
  const rentYear = format(rentStartDate, "yyyy");

  const apartments = calculation?.baseCalculation?.apartmentsCalculation;
  const parkings = calculation?.baseCalculation?.parkingsCalculation;

  const managementCostGrowth =
    calculation?.baseCalculation?.managementCostGrowth;
  const managementCostGrowthDynamic =
    calculation?.baseCalculation?.managementCostGrowthDynamic;
  //===> finishYear

  const maintenanceCostPerSqMeterGrowth =
    calculation?.baseCalculation?.maintenanceCostPerSqMeterGrowth;
  const maintenanceCostPerSqMeterGrowthDynamic =
    calculation?.baseCalculation?.maintenanceCostPerSqMeterGrowthDynamic;
  //===> finishYear

  const aptDowntimeLossPercent =
    calculation?.baseCalculation?.apartmentsCalculation?.aptDowntimeLossPercent;
  const downtimePercentageDynamic =
    calculation?.baseCalculation?.downtimePercentageDynamic;
  //===> rentYear

  const objectGrowthCardData = [
    {
      type:
        managementCostGrowthDynamic > 1
          ? `Instandhaltungskosten steigen erstmalig im ${finishYear} (danach alle ${managementCostGrowthDynamic} Jahre)`
          : `Instandhaltungskosten steigen erstmalig im ${finishYear} (danach jedes Jahr)`,
      quantity: convertValueToLocale(managementCostGrowth, 2, "%"),
    },
    {
      type:
        maintenanceCostPerSqMeterGrowthDynamic > 1
          ? `Instandhaltungskosten steigen erstmalig im ${finishYear} (danach alle ${maintenanceCostPerSqMeterGrowthDynamic} Jahre)`
          : `Instandhaltungskosten steigen erstmalig im ${finishYear} (danach jedes Jahr)`,
      quantity: convertValueToLocale(maintenanceCostPerSqMeterGrowth, 2, "%"),
    },
    ...apartments.flatMap(
      (apartment: any, index: number, apartments: any[]) => [
        {
          type:
            apartment.aptPriceGrowthDynamic > 1
              ? `Wohnungswert ${
                  apartments.length > 1 ? index + 1 : ""
                } steigt erstmalig im ${propertyGrowthYear} (danach alle ${
                  apartment.aptPriceGrowthDynamic
                } Jahre)`
              : `Wohnungswert ${
                  apartments.length > 1 ? index + 1 : ""
                } steigt erstmalig im ${propertyGrowthYear} (danach jedes Jahr)`,
          quantity: convertValueToLocale(apartment.aptPriceGrowth, 2, "%"),
        },
        {
          type:
            apartment.aptRentGrowthDynamic > 1
              ? `Wohnungsmiete ${
                  apartments.length > 1 ? index + 1 : ""
                } steigt erstmalig im ${rentYear} (danach alle ${
                  apartment.aptRentGrowthDynamic
                } Jahre)`
              : `Wohnungsmiete ${
                  apartments.length > 1 ? index + 1 : ""
                } steigt erstmalig im ${rentYear} (danach jedes Jahr)`,
          quantity: convertValueToLocale(apartment.aptRentGrowth, 2, "%"),
        },
      ]
    ),
    ...parkings.flatMap((parking: any, index: number, parkings: any[]) => [
      {
        type:
          parking.parkingPriceGrowthDynamic > 1
            ? `Stellplatzwert ${
                parkings.length > 1 ? index + 1 : ""
              } steigt erstmalig im ${propertyGrowthYear} (danach alle ${
                parking.parkingPriceGrowthDynamic
              } Jahre)`
            : `Stellplatzwert ${
                parkings.length > 1 ? index + 1 : ""
              } steigt erstmalig im ${propertyGrowthYear} (danach jedes Jahr)`,
        quantity: convertValueToLocale(parking.parkingPriceGrowth, 2, "%"),
      },
      {
        type:
          parking.parkingRentGrowthDynamic > 1
            ? `Stellplatzmiete  ${
                parkings.length > 1 ? index + 1 : ""
              } steigt erstmalig im ${rentYear} (danach ${
                parking.parkingRentGrowthDynamic
              } Jahre)`
            : `Stellplatzmiete ${
                parkings.length > 1 ? index + 1 : ""
              } steigt erstmalig im ${rentYear} (danach jedes Jahr)`,
        quantity: convertValueToLocale(parking.parkingRentGrowth, 2, "%"),
      },
    ]),
    {
      type:
        downtimePercentageDynamic > 1
          ? `Leerstand steigt alle ${downtimePercentageDynamic} Jahre)`
          : `Leerstand steigt jedes Jahr`,
      quantity: convertValueToLocale(aptDowntimeLossPercent, 2, "%", "0,00%"),
    },
  ];

  return objectGrowthCardData;
};

export const bottomText = `Die Entwicklung von Immobilienpreis und Miete basiert auf modellhaften Annahmen und dient lediglich der Orientierung. Es handelt sich dabei nicht um eine Prognose oder Garantie - tatsächliche Preis- oder Mietentwicklungen können davon deutlich abweichen.
Der Risikoabschlag für laufende Kosten (in Euro) wird nach Steuern (netto) angegeben. Falls diese Kosten - z. B. für Instandhaltung - steuerlich absetzbar sind, kann der tatsächliche Aufwand vor Steuern (brutto) entsprechend höher liegen.`;
